import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const SettingsContext = createContext({});

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get('/settings/public')
      .then(r => { setSettings(r.data); setLoaded(true); })
      .catch(() => setLoaded(true));
  }, []);

  const s = (key, fallback = '') => settings[key] ?? fallback;

  return (
    <SettingsContext.Provider value={{ settings, loaded, s }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
